export default __webpack_public_path__ + "static/media/brightness-low.b15e3a4f.svg";